import React, { useCallback, useState } from 'react';
import {
  LineSeparator,
  VideoBlockContainer,
  VideoImageContainer,
  VideoIframe,
  VideoInfoContainer,
  VideoInfoDescription,
  VideoInfoTitle,
  VideoSectionContainer,
  VideoSubscriptionButtonContainer,
  VideoClose,
} from './VideoBlockStyle';
import { withContent } from '../../hoc/withContext';
import { IContent } from '../../types';
import SubscriptionButton from '../UI/Buttons/SubscriptionButton/SubscriptionButton';
import { ReactComponent as CloseButton } from '../../assets/video_close_icon.svg';
import { adobeTrack, getImage } from '../../utils/Functions';
import PictureImage from '../../utils/Image/PictureImage';
interface IVideoBlockProps {
  context?: IContent;
}

const VideoBlock = ({ context } : IVideoBlockProps) => {
  const [showVideo, setShowVideo] = useState(false)

  const toggleVideo = useCallback(() => {
    setShowVideo(state => !state)
    document.body.style.overflowY = !showVideo ? 'hidden' : 'scroll'
    if(!showVideo)
      adobeTrack(context.video.tracking);
  },[setShowVideo,showVideo])

  return (
    <VideoBlockContainer>
      <VideoClose fullScreenVideo={showVideo}  onClick={() => toggleVideo()}><CloseButton/> </VideoClose>
      {showVideo &&
                      <VideoIframe src={context.video.videoLink + '?autoplay=1'}
                                  title="Ubisoft plus rewards" frameBorder="0"
                                  allowFullScreen allow={"autoplay; fullscreen"}/>
                    }

      <VideoInfoTitle isMobileTitle={true}>{context.video.title}</VideoInfoTitle>
      <VideoSectionContainer>
        <VideoImageContainer onClick={() => toggleVideo()}>
          <PictureImage
            images={getImage('rewards_video_image', false)}
            extension="png"
            altText={'rewards_video_image'}
            className={['']}
          />
        </VideoImageContainer>
      </VideoSectionContainer>
      <VideoInfoContainer>
        <VideoInfoTitle isMobileTitle={false}>{context.video.title}</VideoInfoTitle>
        <VideoInfoDescription dangerouslySetInnerHTML={{ __html: context.video.description }} />
        <VideoSubscriptionButtonContainer>
          <SubscriptionButton context={''} idToAttach={'videoSubscription'} />
        </VideoSubscriptionButtonContainer>
      </VideoInfoContainer>
      <LineSeparator />
    </VideoBlockContainer>
  );
};

export default withContent(VideoBlock);